export const environment = {
  production: true,
  hmr: false,
  debug: false,
  client: 'Lexus',
  hostName: 'insight.amazingdigitalexperiences.com',
  environmentName: 'production',
  appName: 'Lexus Analytics',
  applicationInsights: {
    instrumentationKey: '6f008b6e-796a-4b20-9b95-4eac70d4c068'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Eastern Standard Time',
  showLocaleSelector: 'false',
  numberOfMonthsToShowDefault: 12,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  ssoPassword: 'ShiftDigital#123',
  defaultChartColors: ['#000', '#666666', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  baseApiUri: 'https://lexus-analytics-api-prod-v2.azurewebsites.net/api',
  authUri: 'https://lexus-analytics-api-prod-v2.azurewebsites.net/token',
  baseV5ApiUri: 'https://lexusus-analytics-apiv5-prod.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: false,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/lexus/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
  v5Reports: ['InventoryOverview']
};
